import { render, staticRenderFns } from "./AccordionMenu.vue?vue&type=template&id=29a93114&scoped=true&"
import script from "./AccordionMenu.vue?vue&type=script&lang=js&"
export * from "./AccordionMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccordionMenu.vue?vue&type=style&index=0&id=29a93114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a93114",
  null
  
)

export default component.exports